import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { Money } from '../../type/order/Money';
import { LocalDateTimeRange } from '../../type/shared';
export var PerMinuteFeeChargeStatus;
(function (PerMinuteFeeChargeStatus) {
    PerMinuteFeeChargeStatus["Settled"] = "settled";
    PerMinuteFeeChargeStatus["Failed"] = "failed";
})(PerMinuteFeeChargeStatus || (PerMinuteFeeChargeStatus = {}));
export class PerMinuteFeeCharge {
    constructor(amount, duration, timeRange, status) {
        this.duration = duration;
        this.status = status;
        this.amount = amount;
        this.timeRange = timeRange;
    }
}
__decorate([
    Type(() => Money),
    __metadata("design:type", Money)
], PerMinuteFeeCharge.prototype, "amount", void 0);
__decorate([
    Type(() => LocalDateTimeRange),
    __metadata("design:type", LocalDateTimeRange)
], PerMinuteFeeCharge.prototype, "timeRange", void 0);
